import "./style.css";
import Editor from "./components/Editor";

window.onload = () => {
    new Editor()
}